// extracted by mini-css-extract-plugin
export var modalFooter = "_qz-0";